export const getWorkflowCompletionHeaders = (workflowCompletion: any) => {
  return {
    'x-workflow-completion-id': workflowCompletion?.id ?? '',
    'x-workflow-step-id': workflowCompletion?.currentStep?.id ?? '',
    'x-workflow-sub-step-id': workflowCompletion?.currentSubStep?.id ?? '',
  };
};
